import React, { useEffect } from "react";
import Isotope from "isotope-layout";
import AOS from "aos";
import "aos/dist/aos.css";
import { useCollection } from "../hooks/useCollection";

const FILTERS = [
  { filter: "*", label: "All" },
  { filter: ".filter-app", label: "Seminar" },
  { filter: ".filter-card", label: "Study" },
  { filter: ".filter-web", label: "Travel" },
];

const Portfolio = () => {
  const { items, loading } = useCollection("portfolio", "order", "asc");

  useEffect(() => {
    if (loading || items.length === 0) return;

    const container = document.querySelector(".portfolio-container");
    if (!container) return;

    const iso = new Isotope(container, {
      itemSelector: ".portfolio-item",
      layoutMode: "fitRows",
    });

    const filterEls = document.querySelectorAll("#portfolio-flters li");
    const handlers = [];
    filterEls.forEach((el) => {
      const handler = function (e) {
        e.preventDefault();
        filterEls.forEach((x) => x.classList.remove("filter-active"));
        this.classList.add("filter-active");
        iso.arrange({ filter: this.getAttribute("data-filter") });
        iso.on("arrangeComplete", () => AOS.refresh());
      };
      el.addEventListener("click", handler);
      handlers.push({ el, handler });
    });

    iso.arrange({ filter: "*" });

    return () => {
      handlers.forEach(({ el, handler }) =>
        el.removeEventListener("click", handler)
      );
      iso.destroy();
    };
  }, [items, loading]);

  return (
    <section id="portfolio" className="portfolio">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Gallery</h2>
          <p>ภาพกิจกรรมของทางชมรมฯ</p>
        </div>

        {loading ? (
          <div className="text-center text-muted py-4">กำลังโหลด...</div>
        ) : items.length === 0 ? (
          <div className="text-center text-muted py-4">ยังไม่มีภาพใน Gallery</div>
        ) : (
          <>
            <div className="row" data-aos="fade-up" data-aos-delay="100">
              <div className="col-lg-12">
                <ul id="portfolio-flters">
                  {FILTERS.map((f, i) => (
                    <li
                      key={f.filter}
                      data-filter={f.filter}
                      className={i === 0 ? "filter-active" : ""}
                    >
                      {f.label}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div
              className="row portfolio-container"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {items.map((item) => (
                <div
                  key={item.id}
                  className={`col-lg-4 col-md-6 portfolio-item filter-${item.category}`}
                >
                  <div className="portfolio-wrap">
                    <img
                      src={item.imageUrl}
                      className="img-fluid"
                      alt={item.title}
                    />
                    <div className="portfolio-links">
                      <a
                        href={item.imageUrl}
                        data-gallery="portfolioGallery"
                        className="portfolio-lightbox"
                        title={item.title}
                      >
                        <i className="bi bi-plus"></i>
                      </a>
                    </div>
                    <div className="portfolio-info">
                      <h4>{item.title}</h4>
                      <p>
                        {FILTERS.find((f) => f.filter === `.filter-${item.category}`)
                          ?.label || ""}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Portfolio;
